import styled from 'styled-components';

export const Header = styled.div<{ $top: number }>`
  position: fixed;
  left: 0;
  right: 0;
  z-index: 5;
  top: ${({ $top }) => $top}px;
  background: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.black3};
`;

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 0 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
  max-width: 840px;
  margin: 0 auto;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
`;

export const StyledImage = styled.img`
  width: fit-content;
  max-width: 100%;
`;
